// Google Maps API Configuration
// You can get your API key from: https://console.cloud.google.com/google/maps-apis/overview

export const GOOGLE_MAPS_CONFIG = {
  // For development: use environment variable or the key below
  // Make sure the key allows localhost:3000 in Google Cloud Console
  apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || 'AIzaSyDa1qKrdh2QYz82JGfYE_mo99qAwWZjjAQ',
  version: 'weekly' as const,
  libraries: ['places'] as ('places')[],
  region: 'CH', // Switzerland
  language: 'fr', // French
};

// Geneva canton geographical bounds for search restriction (slightly expanded)
export const GENEVA_BOUNDS = {
  southwest: { lat: 45.85, lng: 5.85 },
  northeast: { lat: 46.55, lng: 6.55 }
};

// Geneva city center coordinates for location bias
export const GENEVA_CENTER = {
  lat: 46.2044,
  lng: 6.1432
};

// Make sure to enable the following APIs in your Google Cloud Console:
// - Places API
// - Geocoding API  
// - Maps JavaScript API 